import { useLocation } from "react-router-dom"

export default function setImageManual() {

    const HandleFilter = () => {
        const location = useLocation();
        const listImages = [{
            page: "/clients",
            img: [
                require('../../assets/Configurações/Clientes/Clientes.png'),
                require('../../assets/Configurações/Clientes/Clientes - Inserir Logo.png'),
                require('../../assets/Configurações/Clientes/Clientes - Preview logo.png'),
                require('../../assets/Configurações/Clientes/Clientes - Usuarios Cadastrados.png'),
            ]
        },{
            page: "/permission",
            img: [
                require('../../assets/Configurações/Permissoes/Permissoes.png'),
                require('../../assets/Configurações/Permissoes/Usuarios cadastrados.png'),
                require('../../assets/Configurações/Permissoes/Criar perfil de acesso.png'),
                require('../../assets/Configurações/Permissoes/Criar perfil de acesso - permissoes.png'),
            ]
        },{
            page: "/synchronize",
            img: [
                require('../../assets/Configurações/Sincronizacao/Sincronizacao.png'),
                require('../../assets/Configurações/Sincronizacao/Consultar Logs.png'),
            ]
        },{
            page: "/users",
            img: [
                require('../../assets/Configurações/Usuarios/Usuarios.png'),
                require('../../assets/Configurações/Usuarios/Novo Usuario.png'),
                require('../../assets/Configurações/Usuarios/Editar Usuario.png'),
            ]
        }, {
            page: "/dashboard",
            img: [
                require('../../assets/Dashboard/Dashboard.png'),
                require('../../assets/Dashboard/Relatorio Estatistico.png'),
                require('../../assets/Dashboard/Relatorio Estatistico - Preview PDF.png'),
                require('../../assets/Dashboard/Relatorio Analitico.png'),
                require('../../assets/Dashboard/Relatorio Analitico - Filtros.png'),
                require('../../assets/Dashboard/Relatorio Analitico - Preview PDF.png'),
            ]
        }, {
            page: "/home",
            img: [
                require('../../assets/Home/Home.png'),
                require('../../assets/Home/Menu lateral.png'),
                require('../../assets/Home/Menu lateral-1.png'),
                require('../../assets/Home/Perfil logado.png'),
            ]
        }, {
            page: "/editPassword",
            img: [
                require('../../assets/Perfil/Trocar Senha.png'),
            ]
        }, {
            page: "/profile",
            img: [
                require('../../assets/Perfil/Editar.png'),
            ]
        }].find(el => el.page === location.pathname)

        return listImages?.img
    }

    return {
        HandleFilter
    }

}



